import { ApiError } from "../../../types/api-error";
import {
  DistanceUnit,
  PackageType,
  StoragePlace,
  StorageTemperatureCondition,
  WeightUnit,
} from "../../../types/order-form";

export type GetStorageAreaRequestBody = {
  id_magazyn: string;
};
export type GetStorageAreaResponse = {
  result: boolean;
  error_code: ApiError;
  payload: GetStorageAreaPayload;
  errors_debug: string[];
};
export type GetStorageAreaPayload = {
  id_magazyn: string;
  kod_magazynu: string;
  opis: string;
  powierzchnia_procentowa: number;
  klasa_magazynu: number;
  czy_medyczny: boolean;
  data_dodania_magazynu: Date;
  obszary_skladowania: GetStorageAreas[];
};
export type GetStorageAreas = {
  id_obszar_skladowania: string;
  kod: string;
  typ_skladowania: StorageType;
  miejsce: StoragePlace;
  podzial_fiskalny: number;
  warunek_temperaturowy: StorageTemperatureCondition;
  opakowania: StorageAreaPackages[];
};
export type StorageAreaPackages = {
  id_opakowanie: string;
  rodzaj_opakowania: StorageAreaPackageType;
  ilosc_opakowan: number;
  dlugosc: number;
  dlugosc_min: number;
  dlugosc_max: number;
  szerokosc: number;
  szerokosc_min: number;
  szerokosc_max: number;
  wysokosc: number;
  wysokosc_min: number;
  wysokosc_max: number;
  waga: number;
  waga_min: number;
  waga_max: number;
  jednostka_wagi: WeightUnit;
  jednostka_dlugosci: DistanceUnit;
};

export enum StorageType {
  Flat = 0,
  High = 1,
  Shelves = 2,
}
export enum FiscalBreakdown {
  CustomsWarehouse = 0,
  CustomsMagazine = 1,
  OrdinaryWarehouse = 2,
}
export enum StorageAreaPackageType {
  Carton = 0,
  BigBag = 1,
  EURPallet = 2,
  HalfEurPallet = 3,
  OtherPallet = 4,
  Other = 5,
}
